import { dataFetcherGet } from 'lib/data-fetcher';
import { BlogPosts, BlogPostsRequestByFilter } from 'models/blog-types';

export const getBlogPosts = async (request: BlogPostsRequestByFilter): Promise<BlogPosts> => {
  const {
    language,
    rootItemId,
    searchTerm,
    blogAudience,
    blogTopics,
    postsToShow,
    showFeaturedPostsOnly,
    database,
    excludeItemId,
  } = request;

  let apiUrl = `/sc-api/custom/blog/getposts/${rootItemId}`;
  apiUrl = `${apiUrl}?postsToShow=${postsToShow || 0}`;
  apiUrl = `${apiUrl}&language=${language || 'en'}`;
  apiUrl = `${apiUrl}&database=${database}`;
  apiUrl = `${apiUrl}&showFeaturedOnly=${showFeaturedPostsOnly ? 1 : 0}`;

  if (searchTerm) {
    apiUrl = `${apiUrl}&searchTerm=${searchTerm || ''}`;
  }

  if (blogTopics) {
    apiUrl = `${apiUrl}&blogTopics=${blogTopics || ''}`;
  }

  if (blogAudience) {
    apiUrl = `${apiUrl}&blogAudience=${blogAudience || ''}`;
  }

  if (excludeItemId) {
    apiUrl = `${apiUrl}&excludeItemId=${excludeItemId}`;
  }

  const defaultReturnData = { posts: [] };

  try {
    const { data } = await dataFetcherGet<BlogPosts>(apiUrl);
    data.posts = data?.posts.filter((d) => d !== null) || [];

    return data || defaultReturnData;
  } catch (e) {
    console.log(`getBlogPosts - Error ${apiUrl}`, e, defaultReturnData);
    return defaultReturnData;
  }
};
